<div class="content">
  <div class="my-show-table">
    <div class="finger-head">
      <mat-form-field class="table-search">
        <mat-label>Search by Email or Name</mat-label>
        <input matInput placeholder="Search by Email or Name" #search [(ngModel)]="email_show"
          (keydown.enter)="onSubmitSearch(search.value)">
      </mat-form-field>

      <mat-form-field>
        <mat-label>Location Tracking</mat-label>
        <mat-select [(value)]="website_id">
          <mat-option [value]="-1">Any</mat-option>
          <mat-option *ngFor="let platform of platforms" [value]="platform.id">
            {{ platform.title }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <button mat-raised-button [ngStyle]="{'background-color': 'var(--primary-color)', 'color': 'var(--light-color)'}"
        class="add-btn" (click)="onSubmitSearch(search.value)"><span
          style="line-height: 24px;margin-right: 5px;display: inline-block;">Download CSV</span></button>
    </div>
    <div class="mat-elevation-z8 ex">
      <table mat-table [dataSource]="dataSource" matSort>
        <ng-container matColumnDef="display_name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header width="25%"> Name </th>
          <td mat-cell *matCellDef="let element"> {{element.first_name}} {{element.last_name}}</td>
        </ng-container>
        <ng-container matColumnDef="email_address">
          <th mat-header-cell *matHeaderCellDef mat-sort-header width="35%"> Email </th>
          <td mat-cell *matCellDef="let element"> {{element.email_address}}</td>
        </ng-container>
        <ng-container matColumnDef="went_online_timestamp">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Registration Date </th>
          <td mat-cell *matCellDef="let element"> {{getFormattedDate(element.went_online_timestamp)}}</td>
        </ng-container>
        <ng-container matColumnDef="location_tracking">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Location Tracking </th>
          <td mat-cell *matCellDef="let element"> {{element.location_tracking ? 'On' : 'Off'}}</td>
        </ng-container>
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef class="show-sm action-col"> Action </th>
          <td mat-cell *matCellDef="let element" class="show-sm action-col" [class]="{'hidden-row': element.hidden}">
            <div class="table-select">
              <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Show Actions"
                [disabled]="element.processing" (click)="UUIDToImperonate = element.UUID">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="editShow(element)">
                  <mat-icon>edit</mat-icon>
                  <span>Edit</span>
                </button>
                <button mat-menu-item (click)="toggleLocationTracking(element)">
                  <mat-icon>{{ element.location_tracking === 1 ? 'location_on' : 'location_off' }}</mat-icon>
                  <span>
                    {{ element.location_tracking === 1 ? 'Location Tracking On' : 'Location Tracking Off' }}
                  </span>
                </button>
                  <button mat-menu-item (click)="change(element)">
                  <mat-icon>group</mat-icon>
                  <span>Manage Collaborators</span>
                </button>
                <button mat-menu-item *ngIf="!AuthService.isImpersonating.value && element.account_assumption_concent_granted"
                  (click)="$event.stopPropagation(); impersonate()" [disabled]="impersonateLoader">
                  <mat-icon>swap_horiz</mat-icon>
                  <span>
                    Impersonate
                  </span>
                  <span class="spinner-container" *ngIf="impersonateLoader">
                    <mat-spinner class="accent-spinner" diameter="20"></mat-spinner>
                  </span>
                </button>
              </mat-menu>
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td colspan="8" class="mat-cell">{{ loading ? 'Loading...' : 'No records found.'}}</td>
        </tr>
      </table>
      <mat-paginator [length]="total_shows" [pageSize]="pageSize" [pageSizeOptions]="[50, 100, 250, 500]"
        (page)="onPageChange($event)" aria-label="Select page of the records."></mat-paginator>
    </div>
  </div>
</div>